<template>
  <div id="page-settlement">
    <el-form
      class="search-form"
      ref="searchForm"
      :inline="true"
      :model="searchForm"
      label-width="6em"
    >
      <el-row>
        <el-form-item prop="regionId" label="Region" required>
          <filter-businessline-region :value.sync="searchForm.regionId" businessLine="2" required />
        </el-form-item>
        <el-form-item label="账期" required>
          <!--          <filter-date-range :value.sync="dateRange" :range="90" :init-range="7" required/>-->
          <el-date-picker
            v-model="periodMonth"
            value-format="yyyy-MM"
            type="month"
            :clearable="false"
            placeholder="选择月"
          />
        </el-form-item>
        <el-form-item style="float: right;">
          <el-button
            type="plain"
            @click="downloadFlowDetails"
            :disabled="!selectedRows.length"
            :loading="downloadFlowLoading"
            >下载流水明细</el-button
          >
          <!-- <el-button type="plain" @click="exportDaily" :loading="exportDailyLoading"
            >导出日结费数据</el-button
          > -->
          <el-button type="primary" @click="fetchData(true)" :loading="isLoading">查询</el-button>
        </el-form-item>
      </el-row>
    </el-form>
    <!-- 列表 -->
    <span
      style="float: right; line-height: 32px;color: #666;margin-right: 10px;font-weight: bold;font-size: 14px;"
      >实收流水汇总：{{ totalSum }}， 骑行收入汇总：{{ rideSum }}， 其它收入汇总：{{ elseSum }}，
      退款汇总：{{ refundSum }}（单位：元）</span
    >
    <el-table
      stripe
      :data="dataList"
      v-loading="isLoading"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" />
      <el-table-column prop="businessLineStr" label="业务线名称" />
      <el-table-column prop="agentName" label="合作商名称" />
      <el-table-column prop="agentId" label="合作商ID" />
      <el-table-column prop="regionId" label="城市ID" />
      <el-table-column prop="regionName" label="城市名称" />
      <el-table-column prop="agentTypeStr" label="合作商类型" />
      <el-table-column prop="chargeTime" label="日期" />
      <el-table-column prop="totalActuallyMoney" label="总实收流水" />
      <el-table-column prop="ridingActuallyMoney" label="骑行收入" />
      <!--      <el-table-column prop="otherMoney" label="其它收入"></el-table-column>-->
      <el-table-column prop="monthCard" label="月卡" />
      <el-table-column prop="timeCard" label="次卡" />
      <el-table-column prop="coupon" label="优惠券" />
      <el-table-column prop="refundActuallyMoney" label="退款" />
      <el-table-column label="操作">
        <template slot-scope="scoped">
          <el-button type="text" @click="exportDetail(scoped.row.id)">下载明细</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="paging-wrapper" v-if="11">
      <el-pagination
        background
        @current-change="handlePageNoChange"
        :current-page.sync="pageNo"
        :page-size="pageSize"
        @size-change="handleSizeChange"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="prev, pager, next, slot, jumper, sizes"
        :total="totalAmount"
      >
        <span class="page-indicator"
          ><em>{{ pageNo }}</em
          >/{{ totalPages }}</span
        >
      </el-pagination>
    </div>
  </div>
</template>

<script>
// import {dateFormat} from '@/utils'
import pagination from '@/mixins/pagination'
import qs from 'qs'

export default {
  mixins: [pagination],

  data() {
    return {
      isLoading: false,
      exportDailyLoading: false,
      downloadFlowLoading: false,
      totalSum: 0,
      elseSum: 0,
      refundSum: 0,
      rideSum: 0,
      selectedRows: [],
      dataList: [],
      dateRange: [],
      periodMonth: '',
      searchForm: {
        regionId: '',
      },
    }
  },

  created() {
    this.initPagination('fetchData', false)
    this.periodMonth = this.initPeriodMonth()
    this.$debugVue('v_settlement', this)
  },

  methods: {
    // 列表
    fetchData(init = false) {
      if (init) this.pageNo = 1
      const params = {
        regionId: this.searchForm.regionId,
        businessLine: 1203,
        periodMonth: this.periodMonth,
        // startTime: dateFormat(this.dateRange[0]),
        // endTime: dateFormat(this.dateRange[1]),
        pageSize: this.pageSize,
        pageNumber: this.pageNo,
      }
      this.isLoading = true
      this.fetch
        .get('settlementList', { params })
        .then(res => {
          const { list = [], total = 0, totalSum, elseSum, refundSum, rideSum } = res.data || {}
          this.isLoading = false
          this.dataList = list
          this.totalAmount = total
          this.totalSum = totalSum
          this.elseSum = elseSum
          this.refundSum = refundSum
          this.rideSum = rideSum
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    async downloadFlowDetails() {
      this.downloadFlowLoading = true
      const params = {
        periodMonth: this.periodMonth,
        region: this.searchForm.regionId,
        ids: this.selectedRows.map(_ => _.id).join(','),
      }
      this.fetch
        .post('flowdownload', null, { params })
        .then(res => {
          this.downloadFlowLoading = false
          if (res.data) {
            window.open(res.data)
          } else {
            this.$message.error('数据错误，请重试')
          }
        })
        .catch(() => {
          this.downloadFlowLoading = false
        })
    },
    getDateString(timestamp) {
      return new Date(timestamp).toLocaleDateString().replace(/\//g, '-')
    },
    initPeriodMonth() {
      const date = new Date()
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      return year + '-' + month.toString().padStart(2, '0')
    },
    async exportDaily() {
      this.exportDailyLoading = true
      const params = {
        periodMonth: this.periodMonth,
        region: this.searchForm.regionId,
      }
      this.fetch
        .post('dailydownload', null, { params })
        .then(res => {
          this.exportDailyLoading = false
          if (res.data) {
            window.open(res.data)
          } else {
            this.$message.error('数据错误，请重试')
          }
        })
        .catch(() => {
          this.exportDailyLoading = false
        })
    },
    handleSelectionChange(val) {
      this.selectedRows = val
    },
    // 导出
    exportDetail(id) {
      const params = {
        id,
        region: this.searchForm.regionId,
      }
      this.isLoading = true
      this.fetch
        .post('settlementDetailExport', qs.stringify(params))
        .then(res => {
          this.isLoading = false
          if (res.data) {
            window.downloadFile(res.data)
          } else {
            this.$message.error('数据错误，请重试')
          }
        })
        .catch(() => {
          this.isLoading = false
        })
    },

    handleSizeChange(size) {
      this.pageSize = size
    },
  },
}
</script>
